import { Directive, ElementRef, Input, AfterViewChecked } from '@angular/core';

@Directive({
  selector: '[appSameHeight]'
})

export class SameHeightDirective implements AfterViewChecked {

  @Input() className: string;

  constructor(private el:ElementRef) { }

  ngAfterViewChecked(){
    this.updateChildren();
  }

  updateChildren(){
    if (this.className != null && this.el != null){
      const children = this.el.nativeElement.getElementsByClassName(this.className);

      if (!children) return;

      Array.from(children).forEach((x: HTMLElement) => {
          x.style.height = 'initial';
      });

      const itemHeights = Array.from(children)
            .map((x: HTMLElement) => x.clientHeight);

      const maxHeight = itemHeights.reduce((prev, curr) => {
              return curr > prev ? curr : prev;
          }, 0);

      Array.from(children)
          .forEach((x: HTMLElement) => x.style.height = `${maxHeight}px`);
    }
  }

}
